import { c as _c } from "react/compiler-runtime";
import { useChartContext } from '#components/chart/context/useChartContext';
import { formatValue } from '#components/chart/utils';
import { cn } from '#lib/utils';
import { TooltipProps } from 'recharts';
import { NameType, ValueType } from 'recharts/types/component/DefaultTooltipContent';
export const TooltipContent = t0 => {
  const $ = _c(7);
  const {
    active,
    payload,
    label
  } = t0;
  const {
    options: t1
  } = useChartContext();
  const {
    size,
    colors
  } = t1;
  if (!active || !payload?.length) {
    return null;
  }
  const firstPayloadItem = payload[0] as PayloadItem;
  if (firstPayloadItem?.payload?.isInterpolated) {
    return null;
  }
  if (!label) {
    console.warn("TooltipContent: label is missing");
  }
  let t2;
  if ($[0] !== colors || $[1] !== label || $[2] !== payload || $[3] !== size) {
    const hasBothValues = payload.every(_temp);
    const isSm = size === "sm";
    t2 = payload.map(item => {
      const isRealValue = item.dataKey === "realValue";
      const currentLabel = getLabel(label ?? "", isRealValue, hasBothValues);
      const value = item.payload.targetValueIndicator ?? formatValue(item.payload[item.dataKey ?? ""]);
      return <div key={`${item.name}${item.value}`} className={cn("text-white px-2 py-1 flex flex-col leading-tight", {
        rounded: !hasBothValues,
        "rounded-t": hasBothValues && isRealValue,
        "rounded-b": hasBothValues && !isRealValue
      })} style={{
        backgroundColor: isRealValue ? colors.TOOLTIP_CURRENT : hasBothValues ? colors.TOOLTIP_TARGET_BOTH : colors.TOOLTIP_TARGET
      }}>{!hasBothValues || isRealValue ? <><p className={isSm ? "text-[12px]" : "text-[14px]"}>{currentLabel}:</p><p className={isSm ? "text-[14px]" : "text-[20px]"}>{value}</p></> : <p className={isSm ? "text-[10px]" : "text-[12px]"}>{currentLabel}: {value}</p>}</div>;
    });
    $[0] = colors;
    $[1] = label;
    $[2] = payload;
    $[3] = size;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <>{t2}</>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
type PayloadItem = NonNullable<TooltipProps<ValueType, NameType>['payload']>[0];
const getLabel = (originalLabel: string, isRealValue: boolean, hasBothValues: boolean) => isRealValue ? originalLabel : hasBothValues ? 'Sihttase' : `${originalLabel} sihttase`;
function _temp(p) {
  return !!p.payload.realValue && !!p.payload.targetValue;
}